<div class="topDiv">
  <div class="agGridOuterDiv">
    <mat-toolbar class="card" style="margin-top: 3%">
      <span class="example-spacer"></span>
      <span i18n="@@spmsPermissions">Permissions</span>
      <button
        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton"
        [style.min-width.px]="90"
        style="font-size: 12px; padding: 0; height: 32px"
        id="102"
        title="Import Data"
        (click)="importData()"
      >
        Import
        <em
          class="fas fa-download"
          style="font-size: 12px; padding: 0 5px"
        ></em>
      </button>

      <button
        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton"
        [style.min-width.px]="90"
        style="font-size: 12px; padding: 0; height: 32px"
        id="103"
        title="Export Data"
        (click)="exportData()"
      >
        Export
        <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px"></em>
      </button>
      <span class="example-spacer"></span>
    </mat-toolbar>
    <div class="legend-section">
      <mat-card appearance="outlined" class="legend-card">
        <div class="legend-items">
          <div class="legend-item">
            <span
              class="legend-icon reauth-icon"
              matTooltip="Re-authentication required to proceed"
              >🛡️</span
            >
            <span class="legend-text"> Re-authentication Required </span>
          </div>
          <div class="legend-item">
            <span
              class="legend-icon critical-icon"
              matTooltip="Digital Signature required to proceed"
              >⛔</span
            >
            <span class="legend-text">Digital Signature Required </span>
          </div>
        </div>
      </mat-card>
    </div>
    <form novalidate [formGroup]="formValid">
      <div class="container" style="padding-left: 0px; margin-left: 0px">
        <div class="row topRowMargins">
          <div class="col-lg-4">
            <mat-form-field appearance="outline" class="role-name-field">
              <mat-label i18n="@@spmsPermissionsUserName">Role Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="userId"
                [(ngModel)]="selectedUserName"
                (click)="openDetailsDialog()"
                readonly
                required
              />
              <mat-error *ngFor="let validation of validation_messages.userId">
                <span
                  class="error"
                  *ngIf="
                    formValid.get('userId').hasError(validation.type) &&
                    (formValid.get('userId').dirty ||
                      formValid.get('userId').touched)
                  "
                >
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="mobileWeb == true">
      <div class="container"></div>
      <mat-card appearance="outlined">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-4 col-sm-12"></div>
              <div class="col-lg-4 col-sm-12">
                <div class="form-group tree-scroll-wrapper">
                  <div class="p-inputgroup mb-2 custom-search-container">
                    <!-- <span class="p-inputgroup-addon">
                      <i class="fas fa-search"></i>
                    </span> -->
                    <input
                      type="text"
                      pInputText
                      class="w-100 p-inputtext-sm search-override-field"
                      (input)="onTreeFilter($event)"
                      #filterInput
                    />
                  </div>

                  <p-tree
                    #tree
                    [value]="items"
                    selectionMode="checkbox"
                    [(selection)]="selectedNodes"
                    [propagateSelectionUp]="true"
                    [propagateSelectionDown]="false"
                    dataKey="key"
                    (selectionChange)="onSelectionChange($event)"
                    class="custom-permission-tree tree-scroll-wrappe"
                  >
                    <ng-template pTemplate="header">
                      <div
                        class="tree-header-root-row d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <p-checkbox
                            [binary]="true"
                            label="All"
                            [(ngModel)]="isAllSelected"
                            (onChange)="toggleSelectAll($event.checked)"
                            class="main-root-checkbox p-tree-node-checkbox"
                          ></p-checkbox>
                          <span class="all-label">All</span>
                        </div>

                        <div class="expand-collapse-toggle-wrapper">
                          <button
                            type="button"
                            class="btn btn-link text-dark p-0 macro-toggle-btn"
                            (click)="toggleGlobalTreeExpansion()"
                            [title]="
                              isTreeExpanded ? 'Collapse All' : 'Expand All'
                            "
                          >
                            <i
                              class="fas"
                              [ngClass]="
                                isTreeExpanded
                                  ? 'fa-compress-arrows-alt'
                                  : 'fa-expand-arrows-alt'
                              "
                            ></i>
                          </button>
                        </div>
                      </div>
                    </ng-template>

                    <ng-template pTemplate="togglericon" let-expanded>
                      <span class="custom-triangle">
                        {{ expanded ? "▼" : "▶" }}
                      </span>
                    </ng-template>

                    <!-- <ng-template pTemplate="header">
    ...
  </ng-template> -->

                    <ng-template pTemplate="default" let-node>
                      <span
                        [ngClass]="node.styleClass"
                        [title]="node.data?.tooltip"
                      >
                        {{ node.label }}
                      </span>
                    </ng-template>
                  </p-tree>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-lg"></div>
          <div class="col-lg text-center">
            <button
              i18n="@@spmsSave"
              type="button"
              (click)="sendData('web')"
              class="SUCButtons btn blue-gradient btn-primary btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            >
              Save
            </button>
            <button
              i18n="@@TMSTAFFMASTERcancel"
              type="button"
              (click)="retrieveWeb()"
              class="SUCButtons btn blue-gradient btn-primary btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding-left: 1.2rem; padding-right: 1.2rem"
            >
              Reset
            </button>
          </div>
          <div class="col-lg"></div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
